// extracted by extract-css-chunks-webpack-plugin
module.exports = {"mainSliderCard":"_1qYq-X","cardImage":"NQVTqS","placeholder":"_1-DFnJ","innerCardText":"_3JQEix","item":"_18_2kf"};